module.exports = __webpack_public_path__ + "static/media/item02.06666f1f.png";